<template>
  <div class="content">
    <div class="container-fluid">
      <div>
        <div
          class="d-flex justify-content-between align-items-center mb-4 bg-white p-3 border border-gray shadow-xs rounded w-100"
        >
          <div>
            <router-link :to="{ path: '/races'}">
              <button
                type="submit"
                class="btn btn-warning text-white active btn-sm px-3 mr-3"
              >Yarışlar</button>
            </router-link>
            <router-link :to="{ path: '/seasons'}">
              <button type="submit" class="btn btn-info btn-sm px-3 mr-3">Sezonlar</button>
            </router-link>

            <router-link :to="{ path: '/members'}">
              <button type="submit" class="btn btn-danger btn-sm px-3 mr-3">Üyeler</button>
            </router-link>
          </div>
          <span></span>
        </div>
        <card>
          <div>
            <b-tabs content-class="mt-3">
              <b-tab title="İçerik" active>
                <div class="row">
                  <div class="col-12 col-md-6 input-group mb-3 d-flex flex-column">
                    <div class="input-group-prepend">
                      <div class="d-flex justify-content-center align-items-center">
                        <span class="input-group-text">Ad Soyad:</span>
                        <span class="ml-3">{{race.full_name}}</span>
                      </div>
                    </div>
                  </div>
                  <div class="col-12 col-md-6 input-group mb-3 d-flex flex-column">
                    <div class="input-group-prepend">
                      <div class="d-flex justify-content-center align-items-center">
                        <span class="input-group-text">Kulüp Adı :</span>
                        <span class="ml-3">{{race.club_name}}</span>
                      </div>
                    </div>
                  </div>
                  <div class="col-12 col-md-6 input-group mb-3 d-flex flex-column">
                    <div class="input-group-prepend">
                      <div class="d-flex justify-content-center align-items-center">
                        <span class="input-group-text">Email :</span>
                        <span class="ml-3">{{race.email}}</span>
                      </div>
                    </div>
                  </div>
                  <div class="col-12 col-md-6 input-group mb-3 d-flex flex-column">
                    <div class="input-group-prepend">
                      <div class="d-flex justify-content-center align-items-center">
                        <span class="input-group-text">Telefon Numarası :</span>
                        <span class="ml-3">{{race.phone}}</span>
                      </div>
                    </div>
                  </div>

                  <div
                    v-if="race.general_music"
                    class="col-12 col-md-6 input-group mb-3 d-flex flex-column"
                  >
                    <div class="input-group-prepend">
                      <div class="d-flex justify-content-center align-items-center">
                        <span class="input-group-text">Element Formu:</span>
                        <a
                          class="ml-3"
                          :href="setUrl(race.general_music,'/basvuru')"
                          target="_blank"
                        >Dosya Aç</a>
                      </div>
                    </div>
                  </div>
                  <div
                    v-if="race.document"
                    class="col-12 col-md-6 input-group mb-3 d-flex flex-column"
                  >
                    <div class="input-group-prepend">
                      <div class="d-flex justify-content-center align-items-center">
                        <span class="input-group-text">İl Müdürlük Belgesi:</span>
                        <a
                          class="ml-3"
                          :href="setUrl(race.document,'/basvuru')"
                          target="_blank"
                        >Dosya Aç</a>
                      </div>
                    </div>
                  </div>
                  <div
                    v-if="race.club_list"
                    class="col-12 col-md-6 input-group mb-3 d-flex flex-column"
                  >
                    <div class="input-group-prepend">
                      <div class="d-flex justify-content-center align-items-center">
                        <span class="input-group-text">Kulüp Listesi:</span>
                        <a
                          class="ml-3"
                          :href="setUrl(race.club_list,'/basvuru')"
                          target="_blank"
                        >Dosya Aç</a>
                      </div>
                    </div>
                  </div>
                  <div
                    v-if="race.extra_documents"
                    class="col-12 col-md-6 input-group mb-3 d-flex flex-column"
                  >
                    <div class="input-group-prepend">
                      <div class="d-flex justify-content-center align-items-center">
                        <span class="input-group-text">Extra Dosya:</span>
                        <a
                          class="ml-3"
                          :href="setUrl(race.extra_documents,'/basvuru')"
                          target="_blank"
                        >Dosya Aç </a>
                      </div>
                    </div>
                  </div>
                </div>
              </b-tab>
              <b-tab title="Oyuncular">
                <table
                  class="table table-hover table-striped table-bordered mb-0 race-inspect-table" v-if="!loading"
                >
                  <thead class="thead-dark">
                    <th v-if="categoryId==51">Takım Adı</th>
                    <th>Ad Soyad</th>
                    <th>Branş</th>
                    <th>Kategori</th>
                    <th>Opsiyonel Kategori</th>
                    <th>Doğum Tarihi</th>
                    <th>Cinsiyet</th>
                    <th>Telefon No</th>
                    <th>Kimlik No</th>
                    <th>Lisans</th>
                    <!--<th>Hes</th>-->
                    <th>Lisans Durumu</th>
                    <th v-if="categoryId!=50">
                      <span v-if="categoryId!=51">Oyuncu Kısa Müziği</span>
                                            <span v-if="categoryId==51">Takım Uzun Müziği</span>

                       </th>
                  
                    <th v-if="categoryId!=50">
                      <span v-if="categoryId!=51">Oyuncu Uzun Müziği</span>
                      <span v-if="categoryId==51">Takım Uzun Müziği</span>
                      </th>
                    <th>İşlemler</th>
                  </thead>
                  <tbody>
                    <tr v-for="(athletes,key) in race.athletes" :key="key">
                      <td v-if="categoryId==51">{{athletes.team}}</td>
                      <td>{{athletes.name}} {{athletes.surname}}</td>
                      <td>{{branches[athletes.branch]}}</td>
                      <td>{{categories[athletes.branch][athletes.category]}}</td>
                      <td>
                        <span v-if="athletes.optionalCategory">{{athletes.optionalCategory}}</span>
                        <span v-if="!athletes.optionalCategory">Seçilmedi</span>
                      </td>
                      <td>{{athletes.birthdate}}</td>
                      <td>{{genders[athletes.gender]}}</td>
                      <td>{{athletes.phone}}</td>
                      <td>{{athletes.tc}}</td>
                      <td>
                        <a
                          v-if="athletes.license"
                          class
                          :href="license(athletes.license)"
                          target="_blank"
                        >Lisans Aç</a>
                      </td>
                      <!--<td>
                        <a
                          v-if="athletes.hes"
                          class
                          :href="hes(athletes.hes)"
                          target="_blank"
                        >Lisans Aç</a>
                      </td>-->
                      <td>
                        <span v-if="!athletes.status">Beklemede</span>
                        <span v-if="athletes.status==2">Revize Talep Edildi</span>
                        <span v-if="athletes.status==1">Onaylandı</span>
                      </td>
                      <td v-if="categoryId!=50">
                        <a
                          v-if="athletes.music"
                          class
                          :href="setUrl(athletes.music,'/sporcump3')"
                          target="_blank"
                        >Kısa Müzik Aç</a>
                        <span v-if="!athletes.music">Yok</span>
                      </td>
                      <td v-if="categoryId!=50">
                        <a
                          v-if="athletes.longMusic"
                          class
                          :href="setUrl(athletes.longMusic,'/sporcump3')"
                          target="_blank"
                        >Uzun Müzik Aç</a>
                        <span v-if="!athletes.longMusic">Yok</span>
                      </td>
                      <td>
                        <a
                          href="javascript:void(0)"
                          class="btn btn-xs btn-danger btn-fill"
                          v-if="athletes.status !== 2 || !athletes.status"
                          v-on:click="changeStatus(race.id,key,2)"
                          v-b-tooltip
                          title="Lisans Revize Talep Et"
                          id="deactivate-athletes.status"
                        >
                          <i class="fas fa-eye-slash"></i>
                        </a>
                        <a
                          href="javascript:void(0)"
                          class="btn btn-xs btn-success btn-fill"
                          v-if="athletes.status != 1 || !athletes.status"
                          v-on:click="changeStatus(race.id,key,1)"
                          v-b-tooltip
                          title="Lisans Kabul Et"
                          id="activate-athletes.status"
                          
                        ><i class="fas fa-eye"></i></a>
                                      <router-link
                :to="{ path: '/race-logs/'+race.id}"
                v-b-tooltip
                title="Logs"
                class="btn btn-warning mb-0 text-white btn-fill btn-xs"
                tag="li"
              >
                                <i class="fas fa-exchange-alt"></i>

              </router-link>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </b-tab>
            </b-tabs>
          </div>
        </card>
      </div>
    </div>
  </div>
</template>
<script>
import Card from "src/components/UIComponents/Cards/Card.vue";
import Checkbox from "src/components/UIComponents/Inputs/Checkbox.vue";
export default {
  data: function() {
    return {
      id: this.$route.params.id,
      // post data
      race: {
        id: null,
        user_id: null,
        post_id: null,
        athletes: null,
        general_music: null,
        document: null,
        club_list: null,
        extra_documents: null,
        status: null,
        notes: null,
        club_name: null,
        email: null,
        phone: null,
        full_name: null
      },
      oldRace: {
        id: null,
        user_id: null,
        post_id: null,
        athletes: null,
        general_music: null,
        document: null,
        club_list: null,
        extra_documents: null,
        status: null,
        notes: null,
        club_name: null,
        email: null,
        phone: null,
        full_name: null
      },
      logs:{
        user_id:null,
        race_id:null,
        old_datas:null,
        new_datas:null
      },
      user_id :this.getCurrentUserDetails().id,
      loading:false,
      branches: {
        0: "Senkronize Buz Pateni",
        1: "Artistik Buz Pateni",
        2: "Short Track"
      },
      categories: {
        0: {
          0: "Pre-Juvenile",
          1: "Juvenile",
          2: "Basic Novice",
          3: "Advanced Novice",
          4: "Mixed Age 1",
          5: "Senior Elite 12",
          6: "Mixed Age 3",
          7: "Junior",
          8: "Senior"
        },
        1: {
          0: "Senior",
          1: "Junior",
          2: "Advanced Novice",
          3: "Intermediate Novice",
          4: "Basic Novice 1",
          5: "Basic Novice 2",
          6: "Pre-Novice",
          7: "Cubs 1",
          8: "Cubs 2",
          9: "Chicks 1",
          10: "Chicks 2"
        },
        2: {
          0: "Men/Women",
          1: "Senior",
          2: "Junior A",
          3: "Junior B",
          4: "Junior C",
          5: "Junior D",
          6: "Junior E",
          7: "Junior F",
          8: "Junior G"
        },
        3: {
          0: "1. Grup",
          1: "2. Grup",
          2: "3. Grup",
          3: "4. Grup"
        },
        4: {
          0: "1. Grup",
          1: "2. Grup",
          2: "3. Grup"
        }
      },
      genders: {
        0: "Kadın",
        1: "Erkek"
      },
      categoryId:null
    };
  },
  components: {
    Checkbox,
    Card
  },
  methods: {
    changeStatus: function(id,key, status) {
      this.loading = true;
      this.toggleLoader();
      this.race.athletes.forEach((e,index)=>{
        if(index==key){
          e.status = status;
        }
      })
    this.race.athletes = JSON.stringify(this.race.athletes);
      this.$http.post("/api/race/edit-athlete/" + id, this.race).then(
        response => {
          // if (status == 1) {
          //   this.notifier("top", "right", "success", "Talep Kabul Edildi");
          // } else if (status == 4) {
          //   this.notifier("top", "right", "warning", "Talep Reddedildi");
          // }
          this.saveLogs();
          this.getInitialData();
          this.toggleLoader();
          
        },
        e => {
                    this.getInitialData();

                     this.toggleLoader();

              if(!e.body.Error){
              this.notifier('top', 'right', 'danger', 'Bir Hata Oluştu')
            }else{
              this.notifier('top', 'right', 'danger', e.body.Error)

            }
        }
      );
    },
    saveLogs: function(){
      const vm = this;
      vm.logs.user_id = vm.user_id;
      vm.logs.race_id = vm.race.id;
      vm.logs.new_datas = vm.race.athletes;
            this.$http.post("/api/race-logs/add/", this.logs).then(
        response => {

           this.getInitialData();
           
        },
        e => {
                    this.getInitialData();

                     this.toggleLoader();

              if(!e.body.Error){
              this.notifier('top', 'right', 'danger', 'Bir Hata Oluştu')
            }else{
              this.notifier('top', 'right', 'danger', e.body.Error)

            }
        }
      );
    },
    setUrl: function(data, path) {
      return this.raceURL() + data + path;
    },
    license: function(data) {
      return this.licenseURL() + data;
    },
    hes: function(data) {
      return this.hesURL() + data;
    },
    getInitialData: function() {
      this.toggleLoader();
      this.$http.get("/api/race/get/" + this.id).then(
        response => {
          this.logs.old_datas = response.body.athletes;
          this.race = response.body;
          if (this.race.athletes) {
            this.race.athletes = JSON.parse(this.race.athletes);
          }
          this.loading = false;
          this.getRace();
          this.toggleLoader();
        },
        er => {
          this.toggleLoader();
          this.notifier(
            "top",
            "right",
            "danger",
            "Yüklenirken bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz."
          );
          return;
        }
      );
    },
    
    getRace: function() {
      this.toggleLoader();
      this.$http.get("/api/posts/get/" + this.race.post_id).then(
        response => {
          this.categoryId = response.body.category_id;
          // this.post = response.body;
          this.toggleLoader();
        },
        er => {
          this.toggleLoader();
          this.notifier(
            "top",
            "right",
            "danger",
            "Yüklenirken bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz."
          );
          return;
        }
      );
    },
  },
  mounted: function() {
    this.$nextTick(function() {
      this.getInitialData();
      
    });
  }
};
</script>
<style>
.race-inspect-table thead th {
  font-size: 14px !important;
}
.race-inspect-table tbody tr td {
  font-size: 14px;
}
.race-inspect-table tbody tr td a {
  font-size: 12px !important;
}
.input-group-text.is-valid {
  border-color: #28a745 !important;
}
.input-group-text {
  transition: 300ms;
}
.input-group-text.is-invalid {
  border-color: #dc3545 !important;
  background-color: #dc3545;
  color: #fff;
}
.form-check-label {
  font-size: 16px !important;
  line-height: 15px !important;
  text-transform: capitalize !important;
}
.seo-text {
  background-color: #e9ecef;
  border: 1px solid #ced4da;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/RaceModules/Inspect.vue